import * as React from "react";
import { useCountUp } from "react-countup";
import { Card, Text } from "@mantine/core";

interface IProps {
    label: string;
    value: number | null;
    color: string;
    isLoading: boolean;
}

const SongStatItem = ({
    label,
    value,
    color,
    isLoading
}: IProps) => {

    const countUpRef = React.useRef(null);

    const { start, pauseResume, reset, update } = useCountUp({
        ref: countUpRef,
        start: 0,
        end: value === null ? 999_999 : value,
        duration: value === null ? 600 : 1,
    })

    React.useEffect(() => {
        if (isLoading) {
            start()
        }
    }, [isLoading]);

    React.useEffect(() => {
        if (value !== null) {
            reset();
            update(value);
        }
    }, [value]);

    return (
        <Card p='sm' radius='md' style={{ backgroundColor: color, width: 220 }}>
            <Card.Section p='inherit' c={'white'}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Text fz={16}>
                        {label}
                    </Text>
                    <Text ta='right' fw={700} fz={20} c={'white'} ref={countUpRef}/>
                </div>
            </Card.Section>
        </Card>
    )
};

export default SongStatItem;